// Storefront checkout rules. Mirrors backend/src/utils/checkoutConfig.js —
// keep both in sync. The backend re-prices every order, so these values only
// drive what the shopper sees before submitting.

export const FREE_SHIPPING_THRESHOLD = 200;

export const SHIPPING_METHODS = [
    { id: "dhl_courier", price: 16, logo: "/img/logos/dhl.svg" },
    // DHL collects the payment on delivery, so the payment step is skipped.
    { id: "dhl_cod", price: 20, logo: "/img/logos/dhl.svg", paymentMethod: "cod" },
];

export const PAYMENT_METHODS = ["payu", "bank_transfer"];

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export const getShippingMethod = (id) => SHIPPING_METHODS.find((m) => m.id === id) || null;

/** Same formula as backend orderPricing.computeDiscountAmount. */
export const computeDiscountAmount = (subtotal, discount) => {
    const value = Number(discount?.value);
    if (!discount?.discountType || !Number.isFinite(value) || value <= 0 || subtotal <= 0) return 0;
    const raw = discount.discountType === "percent" ? (subtotal * Math.min(value, 100)) / 100 : value;
    return round2(Math.min(raw, subtotal));
};

/**
 * Totals for the basket. `shippingMethodId` may be null before the shopper
 * picks one; shipping is then reported as null (unknown yet).
 */
export const computeTotals = (products, discount, shippingMethodId = null) => {
    // Sold-out lines stay visible in the bag but are not part of the order.
    const subtotal = round2(
        (products || []).filter((item) => !item.unavailable).reduce(
            (sum, item) => sum + Number(item.new_price ?? item.price ?? 0) * Number(item.quantity ?? 1),
            0
        )
    );
    const discountAmount = computeDiscountAmount(subtotal, discount);
    const discounted = round2(subtotal - discountAmount);
    const freeShipping = discounted >= FREE_SHIPPING_THRESHOLD;
    const method = getShippingMethod(shippingMethodId);
    const shipping = method ? (freeShipping ? 0 : method.price) : null;
    return {
        subtotal,
        discountAmount,
        discounted,
        freeShipping,
        missingForFreeShipping: freeShipping ? 0 : round2(FREE_SHIPPING_THRESHOLD - discounted),
        shipping,
        total: round2(discounted + (shipping ?? 0)),
    };
};

export const formatPLN = (amount) => `${Number(amount || 0).toFixed(2)} zł`;
